import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, TitleStrategy } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { errorInterceptor } from './app/core/interceptors/error.interceptor';
import { tenantInterceptor } from './app/core/interceptors/tenant.interceptor';
import { secureInterceptor } from './app/core/interceptors/secure.interceptor';
import { vaultAuthInterceptor } from './app/core/interceptors/vault-auth.interceptor';
import { CmTitleStrategy } from './app/core/strategies/cm-title.strategy';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),provideRouter(routes),
    provideHttpClient(
      // Order matters: interceptors run left-to-right on the request and right-to-left on the
      // response, so the last one sits closest to the network.
      withInterceptors([
        tenantInterceptor,   // First: Add tenant headers
        authInterceptor,     // Second: Committee token — skips vault paths
        vaultAuthInterceptor,// Third: Vault's in-memory token + refresh-on-401
        errorInterceptor,    // Fourth: Handle errors — sees plaintext, since secure decrypts first
        secureInterceptor    // Last: Encrypt the body once every other header is in place
      ])
    ),
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { timezone: '+0530' } },
    { provide: TitleStrategy, useClass: CmTitleStrategy }
  ]
}).catch(err => console.error(err));
